module.exports = __webpack_public_path__ + "img/appltCourse-img30.1df087c2.png";